import { useEffect, useState } from "react";
import { Cake, MessageCircle, Phone } from "lucide-react";
import { api } from "../lib/api";
import { Avatar } from "./Avatar";

const wish = (b) => encodeURIComponent(`Tanti auguri di buon compleanno ${b.nome_proprio}! Da tutto il Porto di Roma`);

export function BirthdaysToday() {
  const [list, setList] = useState([]);
  useEffect(() => { api("/web/birthdays-today").then((r) => setList(r.compleanni || [])).catch(() => setList([])); }, []);
  if (!list.length) return null;
  return (
    <section className="mb-12 fade-up" data-testid="birthdays-today">
      <h2 className="font-display text-xl font-bold text-[var(--navy)] mb-4 flex items-center gap-2"><Cake className="w-5 h-5 text-[var(--teal)]" />Compleanni di oggi</h2>
      <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {list.map((b, i) => (
          <li key={b.user_id} className="panel !p-4 min-w-0 flex items-center gap-3 !border-[var(--teal)] !bg-[var(--teal-soft)]" data-testid={`birthday-${i}`}>
            <Avatar src={b.foto} size="w-14 h-14" testid={`birthday-${i}-avatar`} />
            <div className="min-w-0 flex-1"><p className="font-semibold text-[var(--navy)] truncate">{b.nome}</p>
              <p className="text-xs text-slate-500 truncate">{b.eta ? `${b.eta} anni` : "Compie gli anni oggi"}{b.mansioni.length ? ` · ${b.mansioni.join(", ")}` : ""}</p></div>
            {b.telefono ? (
              <div className="flex gap-1.5 shrink-0">
                <a href={`tel:+${b.telefono}`} aria-label={`Chiama ${b.nome}`} className="w-9 h-9 rounded-full bg-[var(--teal)] text-white flex items-center justify-center hover:scale-105 transition-transform" data-testid={`birthday-${i}-call`}><Phone className="w-4 h-4" /></a>
                <a href={`https://wa.me/${b.telefono}?text=${wish(b)}`} target="_blank" rel="noreferrer" aria-label={`Auguri su WhatsApp a ${b.nome}`} className="w-9 h-9 rounded-full bg-[#25D366] text-white flex items-center justify-center hover:scale-105 transition-transform" data-testid={`birthday-${i}-whatsapp`}><MessageCircle className="w-4 h-4" /></a>
              </div>) : <span className="text-[11px] text-slate-400 shrink-0" data-testid={`birthday-${i}-no-phone`}>Nessun numero</span>}
          </li>))}
      </ul>
    </section>
  );
}
